import {
    IMPACT_FILTER_REQUESTED,
    IMPACT_FILTER_SUCCEEDED,
    IMPACT_FILTER_FAILED,
    RESET_LITTERS,
    IMPACT_FILTER_ZOOM_CHANGED_REQUESTED,
} from './constants';

export function impactFilterRequested(selectedFilter) {
    return {
        type: IMPACT_FILTER_REQUESTED,
        selectedFilter,
    };
}

export function impactFilterZoomChangedRequested(zoom, dimension) {
    return {
        type: IMPACT_FILTER_ZOOM_CHANGED_REQUESTED,
        zoom,
        dimension,
    };
}

export function impactFilterSucceeded({ impactLitters, hasMoreData }) {
    return {
        type: IMPACT_FILTER_SUCCEEDED,
        impactLitters,
        hasMoreData,
    };
}

export function impactFilterFailed(error) {
    return {
        type: IMPACT_FILTER_FAILED,
        error,
    };
}

export function resetLitters() {
    return {
        type: RESET_LITTERS,
    };
}
